import { gql } from '@apollo/client'

export const BOOKINGLIST_QUERY = gql`
  query BookingList($input: BookingListInput!) {
    bookingList(input: $input) {
      bookingsList {
        bookingDate
        bookerName
        bookingNumber
        displayBookingNumber
        crsStatus
        checkin
        checkout
        currency
        email
        providerName
        guestName
        numberOfRooms
        pmsStatus
        propertyName
        sourceName
        sourceReservationNumber
        totalPrice
      }
      pageInfo {
        current_page
        from
        total
        to
        lastPage
        perPage
      }
    }
  }
`

export const BOOKING_DOWNLOAD_EXCEL_QUERY = gql`
  query BookingListExcel($input: BookingListInput) {
    bookingListExcel(input: $input) {
      excelData
    }
  }
`
